// @flow

import type { FeedbackState } from './types';
import userInitialState from './user/initialState';

const feedbackState = ({
  user: userInitialState,
}: FeedbackState);

export default feedbackState;



// WEBPACK FOOTER //
// ./app/CaptureFeedback/initialState.js